export default __webpack_public_path__ + "static/media/34_Sanfit.d165a137.png";